import { create } from "zustand"

import { TEmailTemplateModal } from "~/types/accounts"

interface IAccountsStore {
  emailTemplateModal: TEmailTemplateModal
  setEmailTemplateModal: (data: TEmailTemplateModal) => void
  downloadAccountDigestModal: boolean
  setDownloadAccountDigestModal: (data: boolean) => void
  showAccountDigestDrawer: any
  setShowAccountDigestDrawer: (data: any) => void
}

const useAccountsStore = create<IAccountsStore>((set) => ({
  emailTemplateModal: null,
  setEmailTemplateModal: (data) => set({ emailTemplateModal: data }),
  downloadAccountDigestModal: false,
  setDownloadAccountDigestModal: (data) =>
    set({ downloadAccountDigestModal: data }),
  showAccountDigestDrawer: false,
  setShowAccountDigestDrawer: (data) => set({ showAccountDigestDrawer: data })
}))

export default useAccountsStore
